import { Transaction } from "./transaction";
import { TradableWallet } from "@models/interfaces/tradable_wallet";

export abstract class TradableTransaction extends Transaction {
	protected amount_eur: string = "";
	protected amount_eur_incl_fee: string = "";
	protected current_fiat_amount: string = "";
	protected current_fiat_id: string = "";
	protected wallet_id = "";
	protected cryptocoin_id: string = "";
	protected related_wallet_id: string = "";

	protected tx_id: string = "";

	protected fee: string = "";

	public abstract getContactId(): string;
	public abstract getDestinationTag(): string;
	public abstract getDtType(): string;
	public abstract getPurposeText(): string;
	public abstract isExternal(): boolean;
	public abstract get isStorageFee(): boolean;

	public hasTxId(): boolean {
		return this.tx_id !== "";
	}

	public getTxId(): string {
		return this.tx_id;
	}

	public getAmountEurInklFee(): string {
		return this.amount_eur_incl_fee;
	}

	public setAmountEurInclFee(s: string): void {
		this.amount_eur_incl_fee = s;
	}

	public getRelatedWalletId(): string {
		return this.related_wallet_id;
	}

	public setWallet(w: TradableWallet): void {
		this.wallet_id = w.getId();
	}

	public getAmountEuro(): string {
		return this.amount_eur;
	}

	public setAmountEuro(s: string): void {
		this.amount_eur = s;
	}

	public hasFees(): boolean {
		return +this.fee > 0 || this.is_bfc;
	}

	public getFee(): number {
		return +this.fee;
	}

	public getCurrentFiatAmount(): string {
		return this.current_fiat_amount;
	}

	public getCurrentFiatId(): string {
		return this.current_fiat_id;
	}

	public get displayRecipient(): string {
		return this.recipient;
	}

	public setCurrentFiatAmount(s: string): void {
		this.current_fiat_amount = s;
	}

	public setCurrentFiatId(s: string): void {
		this.current_fiat_id = s;
	}

	public getCryptocoinId(): string {
		return this.cryptocoin_id;
	}
}
